import React from "react";
import PageHero from "../components/PageHero";
import Industries from "../components/Industries";
import GCCFeature from "../components/GCCFeature";
import Stats from "../components/Stats";
import CTABanner from "../components/CTABanner";
import { IMAGES } from "../config/siteConfig";

export default function IndustriesPage() {
  return (
    <>
      <PageHero
        label="Industries"
        title="Software across"
        highlight="key sectors."
        subtitle="Healthcare, Education, Logistics, Travel, Manufacturing, Fintech, Legal, Pharma, Food, IT and ICT — domains where INRISOFT has delivered 400+ projects."
        image={IMAGES.gcc}
      />
      <Industries />
      <GCCFeature />
      <Stats />
      <CTABanner heading="Building in your sector?" highlight="Talk to us." />
    </>
  );
}
